module.exports = __webpack_public_path__ + "bg.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/bg.svg
// module id = 701
// module chunks = 0